function GetURLParameter(sParam){var sPageURL = window.location.search.substring(1);var sURLVariables = sPageURL.split('&');for (var i = 0; i < sURLVariables.length; i++){var sParameterName = sURLVariables[i].split('=');if (sParameterName[0] == sParam){return sParameterName[1];}}}

$(document).ready(function(){
  var st = GetURLParameter('st');
  if(st=='true'){
    window.location.href = "/";
    $('#home-video-top').removeClass('hidden');
    $('#promo-img').addClass('hidden');
    $('#testimonials-mb').addClass('hidden');
  }
  var hs = GetURLParameter('hs');
  if(hs=='true'){
    window.location.href = "/";
  }
  $('#promo-img').attr('style','');

  //Check Clickbank
  var clickbank = GetURLParameter('clickbank');
  if(clickbank=='true'){
    $('.buynow-link').attr('href','http://1.kranse.pay.clickbank.net/');
    $('.buynow-link').parent().attr('onclick','javascript:void(0)');
    $('.buy-btn .button').attr('href','http://1.kranse.pay.clickbank.net/');
    $('.buy-btn .button').attr('onclick','javascript:void(0)');
  }
});

/* --- owl-testimonials --- */

$(document).ready(function() {

  $("#owl-testimonials").owlCarousel({

    navigation : false, // Show next and prev buttons
    autoPlay: 7000,
    slideSpeed : 900,
    paginationSpeed : 400,
    pagination : false,
    singleItem:true

    // "singleItem:true" is a shortcut for:
    // items : 1, 
    // itemsDesktop : false,
    // itemsDesktopSmall : false,
    // itemsTablet: false,
    // itemsMobile : false

  });

});

$(document).ready(function() {

  $("#owl-testimonials-mb").owlCarousel({

    navigation : false, // Show next and prev buttons
    autoPlay: 7000,
    slideSpeed : 900,
    paginationSpeed : 400,
    pagination : false,
    singleItem:true

    // "singleItem:true" is a shortcut for:
    // items : 1, 
    // itemsDesktop : false,
    // itemsDesktopSmall : false,
    // itemsTablet: false,
    // itemsMobile : false

  });

});





/*! jquery.cookie v1.4.1 | MIT */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof exports?a(require("jquery")):a(jQuery)}(function(a){function b(a){return h.raw?a:encodeURIComponent(a)}function c(a){return h.raw?a:decodeURIComponent(a)}function d(a){return b(h.json?JSON.stringify(a):String(a))}function e(a){0===a.indexOf('"')&&(a=a.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return a=decodeURIComponent(a.replace(g," ")),h.json?JSON.parse(a):a}catch(b){}}function f(b,c){var d=h.raw?b:e(b);return a.isFunction(c)?c(d):d}var g=/\+/g,h=a.cookie=function(e,g,i){if(void 0!==g&&!a.isFunction(g)){if(i=a.extend({},h.defaults,i),"number"==typeof i.expires){var j=i.expires,k=i.expires=new Date;k.setTime(+k+864e5*j)}return document.cookie=[b(e),"=",d(g),i.expires?"; expires="+i.expires.toUTCString():"",i.path?"; path="+i.path:"",i.domain?"; domain="+i.domain:"",i.secure?"; secure":""].join("")}for(var l=e?void 0:{},m=document.cookie?document.cookie.split("; "):[],n=0,o=m.length;o>n;n++){var p=m[n].split("="),q=c(p.shift()),r=p.join("=");if(e&&e===q){l=f(r,g);break}e||void 0===(r=f(r))||(l[q]=r)}return l};h.defaults={},a.removeCookie=function(b,c){return void 0===a.cookie(b)?!1:(a.cookie(b,"",a.extend({},c,{expires:-1})),!a.cookie(b))}});

/* --- Responsive text --- */
//$(function() {
//  $("#fittext1").fitText(1.1, { minFontSize: '18px', maxFontSize: '44px' });
//});

/* --- Sticky --- */
$(window).load(function(){
  $("#header").sticky({ topSpacing: 0 });
});

/* --- Scroll Click --- */
$(function() {
  var a=1;
  $('a[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        var header_height = $("#header").height();
        if(a==1){
          $('html, body').animate({scrollTop: target.offset().top - header_height + 20}, 1000);
          a++;
        }else{
          $('html, body').animate({scrollTop: target.offset().top - header_height}, 1000);
        }
        return false;
      }
    }
  });
});

function add_product(id_variant, qty){
  var url = "/cart.js";
  //var cart_items = 0;
  var exist_product = 0;
  $.getJSON(url, function (results) {
    //cart_items = results.items.length;
    $.each(results.items, function (i, item) {
      if(item.id == id_variant) exist_product = 1;     
    });
    setTimeout(function(){
      if(exist_product == 1){
        location.href="/cart";
      }else{
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data:	{quantity: qty, id: id_variant},
          dataType: 'json',
          error: addToCartFail,
          success: setTimeout(function(){ location.href="/cart"; }, 1500)
        });
      }
    }, 500);
  });
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  var response = $.parseJSON(jqXHR.responseText);
  alert(response.description);
}

//Begin Countdown Timer
function pad(number, length){
  var str = '' + number;
  while (str.length < length) {
    str = '0' + str;
  }
  return str;
}
function new_countdown_timer(total_time){
  if(total_time > 0){
    var minus = Math.floor(total_time / 60);
    minus = pad(minus,2);
    $(".dynamic-minus").html(minus);
    var seconds = Math.floor(total_time - minus*60);
    seconds = pad(seconds,2);
    $(".dynamic-seconds").html(seconds);
  }
  else{
    $(".dynamic-minus").html('00');
    $(".dynamic-seconds").html('00');
    after_time_left();
  }
}
function after_time_left(){
  $(".control-clock").addClass("hidden");
}
$(function(){
  var expires_cookie = 30;
  expires_cookie = parseInt(expires_cookie);
  expires_cookie = expires_cookie/60;        
  expires_cookie = expires_cookie/24;
  var timer_countdown =  $.cookie('timer_countdown');
  if(timer_countdown != undefined && timer_countdown > 0 ){
    setInterval(function(){
      timer_countdown = timer_countdown - 1;
      new_countdown_timer(timer_countdown);
      $.cookie("timer_countdown", timer_countdown, { expires: expires_cookie, path: '/' });
    },1000);
  }
  else{
    if(timer_countdown == undefined){
      timer_countdown = 600;
      setInterval(function(){
        timer_countdown = timer_countdown - 1;
        new_countdown_timer(timer_countdown);
        $.cookie("timer_countdown", timer_countdown, { expires: expires_cookie, path: '/' });
      },1000);
    }
    else{
      after_time_left();
    }
  }
});
//End Countdown Timer


$(document).ready(function() {
  $('.popup-youtube, .popup-vimeo').magnificPopup({
    //disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });

  var current_year = new Date();
  $('.current-year').html(current_year.getFullYear());

  $('.open-popup-notify').magnificPopup({
    type:'inline',
    showCloseBtn: true,
    midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
  });

});

function scrollToElement(selector, time, verticalOffset) {
  time = typeof(time) != 'undefined' ? time : 1000;
  verticalOffset = typeof(verticalOffset) != 'undefined' ? verticalOffset : 0;
  var element = $(selector);
  var offset = element.offset();
  var offsetTop = offset.top + verticalOffset;
  $('html, body').animate({
    scrollTop: offsetTop
  }, time);
}
$( window ).load(function() {
  var sPageURL = window.location.href;
  if (sPageURL.search("#") > -1){
    var param = "#"+document.URL.split('#')[1];
    if (param) {scrollToElement(param, 750, -60);}
  }
});
